import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import EditWebEmailLinkCommand from "./editwebemaillinkcommand";
import { CkeditorConstants } from "../../src/utils/ckeditorconstants";
export default class EditWebEmailLinkUI extends Plugin {
  init() {
    const editor = this.editor;
    this.editor.commands.add(
      "editwebemaillink",
      new EditWebEmailLinkCommand(this.editor)
    );
    this.webLinkEditing(editor)
  }

  webLinkEditing(editor) {
    const editingView = editor.editing.view;

    this.listenTo(editingView.document, "click", (evt, data) => {

      if (data && data.domTarget && data.domTarget.textContent) {
        const resource = data.domTarget.closest('.ref') ? data.domTarget.closest('.ref').getAttribute("resource"): null;
        const typeOf = data.domTarget.closest('.ref') ? data.domTarget.closest('.ref').getAttribute("typeof"): null;

        const checkClassName = data.domTarget.className === "ref" && !data.domTarget.className === "numbered-citation";
        const findClassName = data.domTarget.closest('.ref') && !data.domTarget.closest('.ref').getAttribute('class').includes('numbered-citation');
        if (resource && typeOf && (checkClassName || findClassName))  {
          if (typeOf === CkeditorConstants.attributeWebLink || CkeditorConstants.attributeLinkOtherDocument) { 
            const selection = editor.model.document.selection;
            let linkAttributes = {
              linkText: data.domTarget.textContent,
              linkAddress: resource,
              linkElement: selection
            };
            editor.fire('routeToLink', linkAttributes);
          }
        }
      }
    })
  }
}